import { ICuestionarioPreg, IReporteCV } from 'src/model/candidato-api'
import { CVResp } from './CVResp'
import { chain, forEach, isInteger, map } from 'lodash'

export type T_Opt = {
  opt: string
  obvs: string
}

export type T_RespModel = {
  opt: string // tipo select, option
  opts: T_Opt[] // tipo multiple
  others: T_Opt[] // tipo multiple con allowOthers
  t: string // tipo texto
  val: boolean // tipo yesno
  n: number // tipo numbero
  d: Date // tipo fecha
  f: unknown // para file ?
  yesno: {
    // tipo yesno
    yes: boolean
    no: boolean
    details: null | string
  }
  valid: boolean
}

export class CVModel {
  model: { [idpreg: number]: CVResp }

  resp: CVResp[] = []

  reporteEdicion: IReporteCV | null = null

  valid: boolean = true

  // --------------------------

  paraEdicion(reportecv: IReporteCV) {
    this.reporteEdicion = reportecv
  }

  nuevaPreg(
    q: ICuestionarioPreg,
    superq: ICuestionarioPreg,
    respmodel: T_RespModel,
    idx?: number,
    params?: { [param: string]: any }
  ) {
    let r = new CVResp(q, superq, respmodel, idx)

    this.resp.push(r)

    // si es de tipo  o PARAM2 o PARAMOCULTO, la pregunta puede estar rellena en los parámetros
    if ((q.tq == 'PARAM' || q.tq == 'PARAM2' || q.tq == 'PARAMOCULTO') && params && params[q.q]) {
      respmodel.t = params[q.q]
    }

    if (this.reporteEdicion) {
      // idq
      const idq = Number(q.qref.replace(/^(_ref_)/, ''))

      if (isInteger(idq)) {
        r.conOriginal(this.reporteEdicion.listaRespuestas.respuestas[idq])
      }
    }

    return r
  }

  validar(omitirTipoFile = false) {
    this.valid =
      map(this.resp, (r) => (r.esTipoFile() && omitirTipoFile) || r.validaPreg()).find((valid) => !valid) == undefined

    return this.valid
  }

  respuestas() {
    return chain(this.resp)
      .map((r) => r.generaReq())
      .value()
  }

  respuestasEdicion() {
    return chain(this.resp)
      .flatMap((r) => r.generaReqEdit())
      .value()
  }

  files() {
    return chain(this.resp)
      .flatMap((r) => r.generaFiles())
      .value()
  }

  __rellenaTest() {
    forEach(this.resp, (r) => r.__rellenaTest())
  }
}
